import { render, staticRenderFns } from "./BillingHistory.vue?vue&type=template&id=b2db1928&scoped=true&"
import script from "./BillingHistory.vue?vue&type=script&lang=ts&"
export * from "./BillingHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BillingHistory.vue?vue&type=style&index=0&id=b2db1928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2db1928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
